import React, { Ref, useEffect, useImperativeHandle, useState } from "react";
import { fields } from "./config";
import { Form } from "antd";
import { convertIosStringToDate, formatDateToString } from "helper/common";
import moment from "moment";
import PatientInfoCommon from "components/common/PatientInfoCommon/PatientInfoCommon";
import { useAppSelector } from "redux/hooks";
import { employeeService, examOutService } from "api";
import { Notification } from "components/common";
import dayjs from "dayjs";

export type PatientInfoRef = {
  getFormValue: () => any;
};

type Props = {
  detailDiagnose: any;
  ref?: Ref<PatientInfoRef>;
};
const PatientInfo = React.forwardRef<PatientInfoRef, Props>((props, ref) => {
  const [field, setField] = useState(fields());
  const { detailDiagnose } = props;
  const [form] = Form.useForm();
  const TGChiDinh = useAppSelector((e) => e.diagnose.TGCDDiagnose);
  //set lai value
  useEffect(() => {
    form.setFieldsValue({
      ...detailDiagnose,
      ngayTao: detailDiagnose?.ngayTao ? dayjs(detailDiagnose.ngayTao) : "",
      thoiGianChiDinh: TGChiDinh ? moment(TGChiDinh) : null,
      tuoi:
        moment().year() -
        convertIosStringToDate(detailDiagnose?.ngaySinh)?.year(),
      nvThucHien:
        detailDiagnose?.nvThucHien ?? localStorage.getItem("fullName"),
    });
  }, [detailDiagnose]);

  const formatFormValue = () => {
    const rawValues = form.getFieldsValue();
    const formatValues = {
      ...rawValues,
      ngaySinh: formatDateToString(rawValues.ngaySinh, null),
    };
    return formatValues;
  };

  useImperativeHandle(ref, () => ({
    getFormValue: () => {
      return formatFormValue();
    },
  }));

  const nvThucHien = [
    { value: "Phạm Thị Thanh Hiền" },
    { value: "Lê Thị Hà Uyên" },
    { value: "Nguyễn Thị Hoa" },
    { value: "Vũ Thị Minh Thư" },
    { value: "Đinh Thị Huế" },
    { value: "Phạm Thị Thu Uyên" },
    { value: "Nguyễn Thị Quỳnh Nga" },
    { value: "Tống Thu Thủy" },
    { value: "Nguyễn Thị Hồng Dương" },
    { value: "Nguyễn Thị Hồng" },
  ];

  // getLisDoctor();
  useEffect(() => {
    const searchEmployee = async () => {
      const params = {
        page: 1,
        limit: 2000,
        idChucVu: 25,
      };
      const res = await employeeService.searchEmployee(params);
      console.log("🚀 ~ searchEmployee ~ res:", res);
      const options = res.items.map((item) => ({
        value: item.hoTen,
        label: item.hoTen,
      }));
      return options;
    };

    const getLisDoctor = async () => {
      // Giả sử đây là API call cho getLisDoctor
      const res = await examOutService.getLisDoctor();
      const options = res.data.map((item) => ({
        value: item.hoTen,
        label: `BS. ${item.hoTen}`,
      }));
      return options;
    };

    const fetchData = async () => {
      try {
        const [employeeOptions, doctorOptions] = await Promise.all([
          searchEmployee(),
          getLisDoctor(),
        ]);

        field.find((e) => e.name === "nvThucHien").options = [
          ...nvThucHien,
          // ...employeeOptions,
          ...doctorOptions,
        ];

        setField([...field]);
      } catch (error) {
        console.log("🚀 ~ fetchData ~ error:", error);
        Notification("error", "Đã có lỗi xảy ra khi tải dữ liệu");
      }
    };

    fetchData();
  }, []);

  return (
    <div className="patient-info">
      <Form labelAlign="left" form={form}>
        <PatientInfoCommon data={detailDiagnose} fields={field} />
      </Form>
    </div>
  );
});
export default PatientInfo;
